import { render, staticRenderFns } from "./StatementComparisonGrid.vue?vue&type=template&id=c66cf924"
import script from "./StatementComparisonGrid.vue?vue&type=script&lang=js"
export * from "./StatementComparisonGrid.vue?vue&type=script&lang=js"
import style0 from "./StatementComparisonGrid.vue?vue&type=style&index=0&id=c66cf924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports